import React from "react";
//import { faCreditCard, faTrash } from "@fortawesome/free-solid-svg-icons";
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CardListForSubs = ({
  isOpen,
  isButtonDisabled,
  openModal,
  children,
  handlePaymentCard,
  handlePaymentCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed z-50 inset-0 overflow-y-auto">
      {/* Black Background Overlay */}
      <div className="absolute inset-0 bg-black opacity-75"></div>

      {/* Modal Content */}
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>
        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>
        <div className="px-2 fixed z-50 inset-0 overflow-y-auto flex items-center justify-center">
          <div className="bg-white rounded-lg w-full shadow-xl max-w-lg mx-auto sm:my-8 p-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-bold text-primaryColor ml-12 flex-grow text-center">
                Card List
              </h2>
              <button
                className="bg-primaryColor text-white py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                onClick={openModal}
              >
                Add Card
              </button>
            </div>

            {children}
            <div className="flex items-center justify-between">
              <button
                disabled={isButtonDisabled ? true : false}
                className="md:mr-0 mr-4 cursor-pointer bg-primaryColor mt-2 hover:bg-primaryColor text-white font-bold py-2 px-4 rounded mb-2 focus:outline-none focus:shadow-outline"
                onClick={handlePaymentCard}
              >
                Make Payment
              </button>
              <button
                className="bg-red-700  hover:bg-red-700 text-white  font-medium py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                onClick={handlePaymentCancel}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardListForSubs;
